import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import { styled } from "@material-ui/core/styles";
import IconButton, { IconButtonProps } from "@material-ui/core/IconButton";
import useCustomState from "../../hooks/State";
import ExpandMore from "@material-ui/icons/ExpandMore";
import Collapse from "@material-ui/core/Collapse";
import { convertNumbers } from "../../utils/ConvertNumbers";
import { Split } from "../../utils/Split";
import { LinearProgress } from "@material-ui/core";
import { Typography } from "@material-ui/core";
import { Pie } from "react-chartjs-2";
import { useSelector } from "react-redux";
import { COLORS } from "../../utils/const";

const ExpandMoree = styled((props) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme, expand }) => ({
  transform: !expand ? "rotate(0deg)" : "rotate(180deg)",
  marginLeft: "auto",
  transition: theme.transitions.create("transform", {
    duration: theme.transitions.duration.shortest,
  }),
}));

const ProjectStatistics = (props) => {
  const expanded = useCustomState(true);
  const handleExpandClick = () => {
    expanded.handleChange(!expanded.value);
  };

  const projectsByCities = useSelector((state) => state.projectsByCities);

  const labels = Object.keys(projectsByCities);

  const backgroundColors = labels.map((l, idx) => COLORS[idx % COLORS.length]);

  const data = {
    labels: labels,
    datasets: [
      {
        data: labels.map((label, index) => projectsByCities[label]),
        backgroundColor: backgroundColors,
      },
    ],
  };

  const options = {
    legend: { labels: { fontFamily: "Vazir" }, rtl: false },
    scales: {
      yAxes: [
        {
          display: false,
          ticks: {
            // fontSize: 40
            fontFamily: "Vazir",
            beginAtZero: true,
            userCallback: (label, index, labels) => {
              return Split(convertNumbers(label));
            },
          },
        },
      ],
      xAxes: [
        {
          display: false,
          ticks: {
            fontFamily: "Vazir",
            userCallback: (label, index, labels) => {
              return convertNumbers(label);
            },
          },
          offset: true,
        },
      ],
    },
    tooltips: {
      bodyFontFamily: "Vazir",
      callbacks: {
        title: (tooltipItem, data) => {
          const indice = tooltipItem.index;
          return convertNumbers(data.labels[indice]);
        },
        label: (tooltipItem, data) => {
          const indice = tooltipItem.index;
          return (
            "پروژه های " +
            labels[indice] +
            " - " +
            "تعداد پروژه" +
            ": " +
            Split(convertNumbers(data.datasets[0].data[indice])) +
            ""
          );
        },
      },
    },
  };

  return (
    <div style={{ paddingRight: "8px", paddingLeft: "8px" }}>
      <Card style={{ width: "100%", marginTop: "16px" }}>
        <CardHeader
          style={{ borderBottom: "2px solid #e6e9ed", color: "#73879c" }}
          title={"پروژه های هر شهر"}
          action={
            <ExpandMoree
              expand={expanded.value}
              onClick={handleExpandClick}
              aria-expanded={expanded.value}
              aria-label="show more"
            >
              <ExpandMore />
            </ExpandMoree>
          }
        />
        <Collapse in={expanded.value} timeout="auto" unmountOnExit>
          <CardContent
            style={{ padding: "16px", height: "320px", overflow: "scroll" }}
          >
            <Pie data={data} options={options} />
          </CardContent>
        </Collapse>
      </Card>
    </div>
  );
};

export default ProjectStatistics;
